<template>
  <section class="view-block pt-16 pb-8">
    <RydIcon icon="symbols/error-gear" class="w-full mb-4" />
    <div class="px-4">
      <h3 class="fs-21 font-bold mb-2">
        {{ props.title }}
      </h3>
      <p class="fs-15">
        {{ props.description }}
      </p>
      <RydButton
        v-if="props.hasButton"
        class="mt-6 w-full"
        :name="props.buttonText"
        @click="emit('buttonClick')"
      >
        {{ props.buttonText }}
      </RydButton>
    </div>
  </section>
</template>
<script setup lang="ts">
import RydIcon from '@/components/RydIcon/RydIcon.vue';
import RydButton from '@/components/RydButton/RydButton.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  buttonText: {
    type: String,
    default: '',
  },
  hasButton: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: 'buttonClick'): void;
}>();
</script>